// extracted by mini-css-extract-plugin
module.exports = {"root":"SummaryCard__root--1QPDm","bylineHeader":"SummaryCard__bylineHeader--1Kj-4","bounce":"SummaryCard__bounce--3u1GP"};